<template>
  <div>
    <h3 class="logintitle">登录</h3>
    <p class="titbot">如果您是首次登录我们会自动为你创建账号</p>
    <form class="dxlogin">
      <div class="userwrap divflex">
        <input type="text" class="username" v-model="form.userCode" placeholder="请输入手机号">
      </div>
      <div class="codewrap divflex">
        <input type="number" class="codetxt" v-model="form.phoneCode"  placeholder="请输入验证码">
        <input type="text">
        <input type="button" class="regcodebtn" v-on:click='onLogin':disabled="bool"  v-model="countDown" value="获取验证码">
      </div>
      <input type="button" value="登录" v-on:click='codeLogin' class="codeloginbtn">
      <div class="regpas divflex">
        <a href="javascript:;" class="gopas">密码登录</a>
        <!--<a href="register.html">手机快速注册</a>-->
      </div>
    </form>
    <form class="passlogin">
      <div class="userwrap divflex">
        <input type="text" class="passusername" placeholder="用户名/手机号">
      </div>
      <div class="passwrap divflex">
        <input type="password" class="password"  placeholder="请输入密码">
        <div class="passwordeye invisible"></div>
      </div>
      <input type="button" value="登录" class="passloginbtn">
      <div class="regpas divflex">
        <a href="javascript:;" class="godx">短信登录</a>
        <!--<a href="findpassword.html">找回密码</a>-->
      </div>
    </form>
  </div>
</template>

<script>
  export default {
    name: 'homePage',
    data () {
      return {
        msg: '',
        form:{
          userCode:'',//手机号
          password:'',
          phoneCode:''//手机验证码
        },
        countDown:'获取验证码',
        num:60,//验证码倒计时
        bool:false,//验证码不可点
        code:'',//接受手机验证码
        userId:''
      }
    },
    methods:{
//       this.userid=localStorage.getItem("userid"),
      greet:function () {
        alert(1111)
      },
      onLogin(){
        this.$api.login({mobile:this.form.userCode}).then(res => {
//          resolve(res.data);
          this.userid=localStorage.getItem("userid")
          var _this=this
          console.log(res)
          if(res.status==200){
            this.countDown=this.num+"秒后重发"
            var time=setInterval(function () {
              console.log(111)
              console.log(_this.countDown)
              _this.num--
              if(_this.num==0){
                _this.countDown='获取验证码'
                _this.bool=false
                clearInterval(time)
                _this.num=60
              }else {
                _this.countDown=_this.num+"秒后重发"
                _this.bool=true
              }
            },1000)
            this.code=res.userid
          }
        })
          .catch(err => {
//            reject(err.data)
          })
      },
      codeLogin(){
        console.log(this.code)
//        if(this.code==this.form.phoneCode){
          this.$api.codeLogin({'mobile':this.form.userCode,'logintype':1}).then(res=>{
//          this.$api.codeLogin({'mobile':17610336967,'logintype':2,password:"xi000000"}).then(res=>{
             if(res.status==200){
              localStorage.setItem("userid",res.userid)
               console.log( localStorage.getItem("userid"))
               this.$router.push('/')

             }
            }

          )
//        }

      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
  @import '../assets/css/common.css';
  /*@import '../assets/css/header.css';*/
  /*@import '../assets/css/footer.css';*/
  @import '../assets/css/login.css';
</style>



// WEBPACK FOOTER //
// src/components/login.vue